<template>
  <a @click.prevent="goto">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      linkRouter: {
        AddCollectionPhoto: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        socketMsgMoiveCommunity: () => { window.open(this.$router.resolve({ name: "customerPrivateMessage" }).href, "_blank") },
        likePhotoDtl: () => { window.open(this.$router.resolve({ name: "photoview", query: { Coid: this.item.sgL_PID, Liid: this.item.sgL_LongID } }).href, "_blank") },
        likeMoiveCommunity: () => { window.open(this.$router.resolve({ name: "DisplayVideo", query: { id: this.item.sgL_PID } }).href, "_blank") },
        AcceptFriendsMoiveCommunity: () => { window.open(this.$router.resolve({ name: "groupAddAcc" }).href, "_blank") },
        AddCollectionMoiveCommunity: () => { window.open(this.$router.resolve({ name: "DisplayVideo", query: { id: this.item.sgL_PID } }).href, "_blank") },
        AddCollectionPhotoDtl: () => { window.open(this.$router.resolve({ name: "photoview", query: { Coid: this.item.sgL_PID, Liid: this.item.sgL_LongID } }).href, "_blank") },
        AddMessageMoiveCommunity: () => {
          let link = this.$router.resolve({ name: "DisplayVideo", query: { id: this.item.sgL_LongID } }).href;
          window.open(link, "_blank")
        },
        AddMessagePhotoDtl: () => { window.open(this.$router.resolve({ name: "photoview", query: { Coid: this.item.sgL_PID, Liid: this.item.sgL_LongID } }).href, "_blank") },
        addSubBLog: () => { window.open(this.$router.resolve({ name: "blogDetail", query: { id: this.item.sgL_PID }, }).href, "_blank") },
        AddMessageBLog: () => { window.open(this.$router.resolve({ name: "blogDetail", query: { id: this.item.sgL_PID }, }).href, "_blank") },
        likeBLog: () => { window.open(this.$router.resolve({ name: "blogDetail", query: { id: this.item.sgL_PID }, }).href, "_blank") },
        AddCollectionBLog: () => { window.open(this.$router.resolve({ name: "blogDetail", query: { id: this.item.sgL_PID }, }).href, "_blank") },
        BLogPhoto: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        BLogBLog: () => { window.open(this.$router.resolve({ name: "blogDetail", query: { id: this.item.sgL_PID }, }).href, "_blank") },
        CreateFriendsMoiveCommunity: () => { window.open(this.$router.resolve({ name: "groupAddAcc" }).href, "_blank") },
        addSubPhoto: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        AddMessagePhoto: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        likePhoto: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        NewArticle: () => { window.open(this.$router.resolve({ name: "albumviewPhotostream", query: { id: this.item.sgL_PID } }).href, "_blank") },
        Activity: () => { window.open(this.$router.resolve({ name: "eventview", query: { id: this.item.sgL_PID } }).href, "_blank") },
        MyVideo: () => { window.open(this.$router.resolve({ name: "WatchVideo", query: { id: this.item.sgL_PID, itemtype: "video" }, }).href, "_blank") },
        VideoDtl: () => { window.open(this.$router.resolve({ name: "WatchVideo", query: { id: this.item.sgL_PID, itemtype: "video" } }).href, "_blank") },
        PlayGame: () => { window.open(this.$router.resolve({ name: "/home", query: { id: 1 } }).href, "_blank") },
        MoiveCommunity: () => { window.open(this.$router.resolve({ name: "/home", query: { id: 1 } }).href, "_blank") },
        addSub: () => { window.open(this.$router.resolve({ name: "customerPublish", query: { showBlogSub: 1 } }).href, "_blank") },
        AddFriends: () => { window.open(this.$router.resolve({ name: "feedGroup_groupAddAcc" }).href, "_blank") },
        AddGroup: () => { window.open(this.$router.resolve({ name: "feedGroup_groupAddAcc" }).href, "_blank") },
        AcceptFriendsMoiveCommunity: () => { window.open(this.$router.resolve({ name: "feedGroup_groupAccList" }).href, "_blank") },
        CreateFriendsMoiveCommunity : () => { window.open(this.$router.resolve({ name: "feedGroup_groupAddAcc" }).href, "_blank") },
      }
    }
  },
  created() {
    if (this.item.sgL_LongID.indexOf(',') != -1) {
      this.item.sgL_LongID = this.item.sgL_LongID.split(',')[0];
    }
    if (this.item.sgL_PID.indexOf(',') != -1) {
      this.item.sgL_PID = this.item.sgL_PID.split(',')[0];
    }
  },
  mounted() {
    // this.linkRouter.AddCollectionPhoto();
    // console.log(this.linkRouter['AddCollectionPhoto']);
  },
  methods: {
    // goto() {
    //   let routeData = "";
    //   switch (this.item.sgL_Type) {
    //     case "Photo":
    //       routeData = this.$router.resolve({
    //         name: "albumviewPhotostream",
    //         query: { id: this.item.sgL_PID },
    //       });
    //       break;
    //     case "PhotoDtl":
    //       routeData = this.$router.resolve({
    //         name: "photoview",
    //         query: { Coid: this.item.sgL_PID, Liid: this.item.sgL_LongID },
    //       });
    //       break;
    //     case "NewArticle":
    //       routeData = this.$router.resolve({
    //         name: "articleview",
    //         query: { id: this.item.sgL_PID },
    //       });
    //       break;
    //     case "Activity":
    //       routeData = this.$router.resolve({
    //         name: "eventview",
    //         params: { id: this.item.sgL_PID },
    //       });
    //       break;
    //     case "MyVideo":
    //       routeData = this.$router.resolve({
    // name: "WatchVideo",
    // params: { id: this.item.sgL_PID, itemtype: "video" },
    //       });
    //       break;
    //     case "VideoDtl":
    //       routeData = this.$router.resolve({
    // name: "WatchVideo",
    // params: { id: this.item.sgL_PID, itemtype: "video" },
    //       });
    //       break;
    //     case "PlayGame":
    //       routeData = this.$router.resolve({ name: "/home", query: { id: 1 } });
    //       break;
    //     case "MoiveCommunity":
    //       routeData = this.$router.resolve({ name: "/home", query: { id: 1 } });
    //       break;
    //     case "BLog":
    //       routeData = this.$router.resolve({
    // name: "blogDetail",
    // query: { id: this.item.sgL_PID },
    //       });
    //       break;
    //     case "addSub":
    //       routeData = this.$router.resolve({
    //         name: "customerPublish",
    //         query: { showBlogSub: 1 },
    //       });
    //       break;
    //     case "AddMessage":
    //       if (this.item.sgL_LongID) {
    //         routeData = this.$router.resolve({
    //           name: "feedGroup_FeedGroupDetail",
    //           query: {
    //             sgL_GroupId: this.item.sgL_PID,
    //             id: this.item.sgL_LongID,
    //           },
    //         });
    //       }
    //       break;
    //     case "AddFriends":
    //       routeData = this.$router.resolve({
    //         name: "feedGroup_groupAddAcc",
    //       });
    //       break;
    //     case "AddGroup":
    //       routeData = this.$router.resolve({
    //         name: "feedGroup_groupAddAcc",
    //       });
    //       break;
    //     case "socketMsg":
    //       routeData = this.$router.resolve({
    //         name: "customerPrivateMessage",
    //       });
    //       break;
    //     case "AddCollection":
    //       routeData = this.$router.resolve({
    //         name: "customerPrivateMessage",
    //       });
    //       break;
    //   }
    //   window.open(routeData.href, "_blank");
    // },
    goto() {
      // console.log(this.linkRouter[this.item.sgL_Type + this.item.sgL_MessageType]);
      this.linkRouter[this.item.sgL_Type + this.item.sgL_MessageType]();
    },
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/common/messageLink.vue